/*
 * Copyright (c) 2025 CalAmp Corp.  All Rights Reserved
 */
 
import React from 'react';
import {dlsColor} from '../theme/theme';
import {IconProps} from '../types/types';
import useIconDLS from './useIconDLS';

export interface RetryIconProps extends IconProps {
  disable?: boolean,
  opacity?: number
}

/*
 * Defines the Design Language System (DLS) Retry Icon component.
 */
export const RetryIcon = ({color = dlsColor('grey3'), size, ...props}: RetryIconProps) => {
  const {iconSize, iconColor} = useIconDLS({color, size});
  const {disable, opacity}  = props;
  return (
    <svg width={iconSize} height={iconSize} opacity={disable ? opacity ?? 0.2 : 1} viewBox='0 0 24 24' fill='none'>
      <g clipPath='url(#clip0_21506_24193)'>
        <path d='M6.35023 6.35C7.80023 4.9 9.79023 4 12.0002 4C16.4202 4 19.9902 7.58 19.9902 12C19.9902 16.42 16.4202 20 12.0002 20C8.27024 20 5.16024 17.45 4.27024 14H6.35023C7.17023 16.33 9.39023 18 12.0002 18C15.3102 18 18.0002 15.31 18.0002 12C18.0002 8.69 15.3102 6 12.0002 6C10.3402 6 8.86024 6.69 7.78024 7.78L9.5 9.5L4.27024 9.84945L4.5 4.5L6.35023 6.35Z' fill={iconColor} />
        <circle cx='12' cy='12' r='2' fill={iconColor} />
      </g>
      <defs>
        <clipPath id='clip0_21506_24193'>
          <rect width='24' height='24' fill='white' transform='matrix(-1 0 0 1 24 0)'/>
        </clipPath>
      </defs>
    </svg>
  );
};
